const initCartDrawerOpen = () => {
  const qs = new URLSearchParams(window.location.search);
  const shouldOpen = qs.get('open_cart') === '1' || (() => {
    try {
      return localStorage.getItem('pickmix:openCartOnLoad') === '1';
    } catch (e) {
      return false;
    }
  })();

  if (!shouldOpen) return;

  try {
    localStorage.removeItem('pickmix:openCartOnLoad');
  } catch (e) {}

  const openNow = (drawer) => {
    if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.classList.add('is-open');
      document.body.classList.add('overflow-hidden');
    }
  };

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    openNow(cartDrawer);
    return;
  }

  fetch(window.Shopify.routes.root + '?sections=cart-drawer')
    .then((res) => res.json())
    .then((data) => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data['cart-drawer'];
      const newDrawer = tempDiv.querySelector('cart-drawer');
      const existing = document.querySelector('cart-drawer');

      if (!newDrawer) return;

      if (existing) {
        existing.innerHTML = newDrawer.innerHTML;
        openNow(existing);
      } else {
        document.body.appendChild(newDrawer);
        openNow(newDrawer);
      }
    })
    .catch(() => {});
};

const initPhoneSlideHandler = () => {
  if (!document.body || document.body.hasAttribute('data-phone-slide-bound')) return;

  document.body.setAttribute('data-phone-slide-bound', 'true');

  document.addEventListener(
    'click',
    (e) => {
      const button = e.target.closest('.pay-with-card-with-phone, #pay-with-card-with-phone');
      const phoneSlide = document.querySelector('.monocheckout-phone');

      if (button && phoneSlide) {
        e.preventDefault();
        phoneSlide.classList.add('active');
        return;
      }

      if (phoneSlide && phoneSlide.classList.contains('active')) {
        const clickedInsideSlide = phoneSlide.contains(e.target);
        const clickedButton = !!e.target.closest('.pay-with-card-with-phone, #pay-with-card-with-phone');

        if (!clickedInsideSlide && !clickedButton) {
          phoneSlide.classList.remove('active');
        }
      }
    },
    true
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartDrawerOpen);
  document.addEventListener('DOMContentLoaded', initPhoneSlideHandler);
} else {
  initCartDrawerOpen();
  initPhoneSlideHandler();
}
